import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import ContactInfoBlock from "./components/ContactInfoBlock";
import { MapContainer, PageHeading } from "../../components";
import { useGetCompanyCustomerInfoQuery } from "../../common/queries";
import { useCustomTranslation } from "../../helpers/translateHelpers";

const ContactPage: React.FC = (): React.ReactElement => {
  const { tCommon } = useCustomTranslation();
  const companyAndCustomerQuery = useGetCompanyCustomerInfoQuery();

  const company = companyAndCustomerQuery.data?.company;

  // const handleSubmit = async (values: ContactFormValues) => {
  //   // todo
  // };

  return (
    <>
      <ContentWrapper
        loading={companyAndCustomerQuery.isLoading || !company}
        htmlTitle={tCommon("menu_contact")}
      >
        {company && (
          <div className="grid sm:grid-cols-2">
            <div className="mb-4 sm:mb-0">
              <PageHeading title={company.name} />
              <ContactInfoBlock company={company} />
            </div>
            {company.coordinates && (
              <MapContainer
                center={{
                  lat: company.coordinates.latitude,
                  lng: company.coordinates.longitude,
                }}
                height="270px"
                width="100%"
              />
            )}
            {/* <ContactForm onSubmit={handleSubmit} /> */}
          </div>
        )}
      </ContentWrapper>
    </>
  );
};

export default ContactPage;
